import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const UnlockedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Unlocked",
    children: /*#__PURE__*/_jsx("path", {
      d: "M24.6 13.75H11.26l-.84-2.71a4.78 4.78 0 1 1 9.12-2.85v.04l.29.9 2.7-.85-.28-.9c-1-3.14-3.89-5.37-7.31-5.37-.77 0-1.54.12-2.25.34-3.12 1.01-5.35 3.88-5.35 7.29 0 .8.13 1.58.36 2.3l.58 1.81h-.87a3.35 3.35 0 0 0-3.35 3.35v9.55c0 1.85 1.5 3.35 3.35 3.35h17.2c1.85 0 3.35-1.5 3.35-3.35V17.1c0-1.85-1.5-3.35-3.35-3.35Zm-7.64 8.61v2.85c0 .52-.43.95-.95.95s-.95-.43-.95-.95v-2.85c-1.05 0-1.91-.86-1.91-1.91s.86-1.92 1.91-1.92h1.91c1.05 0 1.92.86 1.92 1.92s-.86 1.91-1.92 1.91Z"
    })
  }));
};